import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, readFile3 } from '../CommonComponents/ExportData';
import { ImportButton } from '../CommonComponents/InputBox';
import { CommonApiData } from "../CommonComponents/EnvConfig";

const BulkBookingImport = () => {
    const dispatch = useDispatch();
    const [SubLoad, setSubLoad] = useState(false);
    const [Status, setStatus] = useState([]);
    const [Name, setName] = useState('');
    const [ImportData, setImportData] = useState([]);
    const [formData, setFormData] = useState({ isUpdate: false, isUpdateAwbNo: false });
   // const loginUserClientCode = CommonApiData().loginUserClientCode;
    const [progress, setProgress] = useState({
        total: 0,
        processed: 0,
        successCount: 0,
        errorCount: 0,
    });

    const requiredHeaders1 = [
        "DocketNo",
        "RefNo",
        "PickupDate",
        "PickupPoint",
        "IsConsignorSave",
        "ConsignorName",
        "ConsignorCompanyName",
        "ConsignorPinCode",
        "ConsignorCity",
        "ConsignorState",
        "ConsignorAddress1",
        "ConsignorMobileNo",
        "ConsignorEmailID",
        "IsConsigneeSave",
        "ConsigneeName",
        "ConsigneeCompanyName",
        "ConsigneePinCode",
        "ConsigneeCity",
        "ConsigneeState",
        "ConsigneeAddress1",
        "ConsigneeMobileNo",
        "ConsigneeEmailID",
        "IsInsurance",
        "InsuranceValue",
        "IsVolWeight",
        "TotalPCS",
        "PacketDescription",
        "PacketType",
        "ServiceMode",
        "ServiceType",
        "ShipmentType",
        "CODAmount",
        "Remarks",
        "VolumetricSelection",
        "BookingType",
        "BuisnessType",
        "EntryFrom"
    ];

    const requiredHeaders2 = [
        "PartNo",
        "ItemCode",
        "Pcs",
        "Weight",
        "Length",
        "Width",
        "Height",
        "BoxDescription"
    ];

    const requiredHeaders3 = [
        "InvoiceNo",
        "InvoiceDate",
        "InvoiceValue",
        "EwayBillNo",
        "EwayBillExpDate"
    ];
    const requiredFields1 = requiredHeaders1.map(key => ({
        label: key,
        icon: "fa-solid fa-file-lines"
    }));

    const requiredFields2 = requiredHeaders2.map(key => ({
        label: key,
        icon: "fa-solid fa-file-lines"
    }));

    const requiredFields3 = requiredHeaders3.map(key => ({
        label: key,
        icon: "fa-solid fa-file-lines"
    }));

    let percentage = progress.total
        ? ((progress.processed / progress.total) * 100).toFixed(0)
        : 0;

    const DownloadFormat = async () => {
        await DownloadFileAtURL('BulkShipmentImport.xlsx');
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'BulkShipmentImportError');
    };

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true));
        let data = await readFile3(e);
        setImportData(data);
        setName(data.FileName);
        await dispatch(setSubLoading(false));
    };

    const handleProgressUpdate = (p) => {
        setProgress({
            total: p.total,
            processed: p.processed,
            successCount: p.successCount,
            errorCount: p.errorCount,
        });
    };

    const handleBulk = async () => {
        if (
            ImportData?.sheet1?.length > 0 &&
            ImportData?.sheet2?.length > 0 &&
            ImportData?.sheet3?.length > 0
        ) {
            const requiredHeaders1 = ["DocketNo",  "RefNo", "PickupDate", "TotalPCS", "PickupPoint", "BookingType", "BuisnessType", "ServiceMode", "VolumetricSelection", "IsConsignorSave", "ConsignorName", "ConsignorCompanyName", "ConsignorPinCode", "ConsignorCity", "ConsignorState", "ConsignorAddress1", "ConsignorMobileNo", "ConsignorEmailID", "IsConsigneeSave", "ConsigneeName", "ConsigneeCompanyName", "ConsigneePinCode", "ConsigneeCity", "ConsigneeState", "ConsigneeAddress1", "ConsigneeMobileNo", "ConsigneeEmailID", "IsInsurance", "InsuranceValue", "IsVolWeight", "PacketDescription", "PacketType", "ServiceType", "ShipmentType", "CODAmount", "Remarks",];

            const requiredHeaders2 = ["DocketNo", "PartNo", "ItemCode", "Pcs", "Weight", "BoxDescription", "Length", "Width", "Height"];

            const requiredHeaders3 = ["DocketNo", "InvoiceNo", "InvoiceDate", "InvoiceValue", "EwayBillNo", "EwayBillExpDate"];

            if (
                requiredHeaders1.every(header =>
                    Object.keys(ImportData?.sheet1?.[0] || {}).includes(header)
                ) &&
                requiredHeaders2.every(header =>
                    Object.keys(ImportData?.sheet2?.[0] || {}).includes(header)
                ) &&
                requiredHeaders3.every(header =>
                    Object.keys(ImportData?.sheet3?.[0] || {}).includes(header)
                )
            ) {

                let bookingData = ImportData.sheet1 || [];
                let weightData = ImportData.sheet2 || [];
                let invoiceData = ImportData.sheet3 || [];

                let finalImportData = bookingData.map((item) => {
                    const weightDetails = weightData.filter(
                        x => x.AwbNo === item.AwbNo
                    );
                    const invoiceDetails = invoiceData.filter(
                        x => x.AwbNo === item.AwbNo
                    );
                    return {
                        entryFrom: "Import",
                        isUpdateAwbNo: formData.isUpdateAwbNo,
                        isInsurance: item.IsInsurance,
                        insuranceValue: item.InsuranceValue,
                        isVolWeight: item.IsVolWeight,
                        packetDescription: item.PacketDescription,
                        volumetricSelection: item.VolumetricSelection,

                        awbNo: item.DocketNo,
                        refNo: item.RefNo,
                        pickupRequestNo:item.PickupRequestNo,
                        pickupDate: item.PickupDate,
                        pickupPoint: item.PickupPoint,

                        bookingType: item.BookingType,
                        buisnessType: item.BuisnessType,

                        serviceMode: item.ServiceMode,
                        serviceType: item.ServiceType,
                        packetType: item.PacketType,
                        shipmentType: item.ShipmentType,
                        codAmount: item.CODAmount,
                        remarks: item.Remarks,
                        totalPCS: item.TotalPCS,

                        isConsignorSave: item.IsConsignorSave,
                        consignorName: item.ConsignorName,
                        consignorCompanyName: item.ConsignorCompanyName,
                        consignorPinCode: item.ConsignorPinCode,
                        consignorCity: item.ConsignorCity,
                        consignorState: item.ConsignorState,
                        consignorAddress1: item.ConsignorAddress1,
                        consignorMobileNo: item.ConsignorMobileNo,
                        consignorEmailID: item.ConsignorEmailID,

                        isConsigneeSave: item.IsConsigneeSave,
                        consigneeName: item.ConsigneeName,
                        consigneeCompanyName: item.ConsigneeCompanyName,
                        consigneePinCode: item.ConsigneePinCode,
                        consigneeCity: item.ConsigneeCity,
                        consigneeState: item.ConsigneeState,
                        consigneeAddress1: item.ConsigneeAddress1,
                        consigneeMobileNo: item.ConsigneeMobileNo,
                        consigneeEmailID: item.ConsigneeEmailID,

                        vendorCode: item.VendorCode,
                        forwardingNo: item.ForwardingNo,

                        dropPoint: item.DropPoint,
                        packetStatus: item.PacketStatus,
                        tripDetails: {
                            tripType: item.TripType,
                            routeName: item.RouteName
                        },

                        weightDetails: weightDetails.map(w => ({
                            partNo: w.PartNo,
                            itemCode: w.ItemCode,
                            pcs: w.Pcs,
                            weight: w.Weight,
                            length: w.Length,
                            width: w.Width,
                            height: w.Height,
                            boxDescription: w.BoxDescription
                        })),

                        invoiceDetails: invoiceDetails.map(i => ({
                            invoiceNo: i.InvoiceNo,
                            invoiceDate: i.InvoiceDate,
                            invoiceValue: i.InvoiceValue,
                            ewayBillNo: i.EwayBillNo,
                            ewayBillExpDate: i.EwayBillExpDate
                        }))
                    };
                });

                await setSubLoad(true);
                await dispatch(setSubLoading(true));

                let Data = await HandleBulkInsertData(
                    "/api/Shipment/InsertUpdateShipmentEntry",
                    finalImportData,
                    {},
                    () => { },
                    handleProgressUpdate
                );

                await setStatus(Data);
                await setSubLoad(false);
                await dispatch(setSubLoading(false));

                BulkClearData(setName);

            } else {
                await NotificationSound(
                    "ERROR",
                    "Header Format is not valid!"
                );
            }
        } else {
            await NotificationSound(
                "ERROR",
                "Please Choose File With Valid Data.!"
            );
        }
    };

    const handleReset = () => {
        setSubLoad(false);
        setStatus([]);
        setName('');
        setImportData([]);
        setProgress({ total: 0, processed: 0, successCount: 0, errorCount: 0 });
    };

    useEffect(() => {
        document.title = 'Bulk Shipment Import';
    }, []);


    return (
        <>
            <div className="bg-white dark:bg-slate-900 rounded-xl border border-gray-100 dark:border-slate-800 shadow-sm">
                <div className="pt-2 px-3 pb-3">

                    {/* Header */}
                    <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center gap-2">
                            <div className="w-8 h-8 rounded-lg bg-[var(--theme-color)] flex items-center justify-center flex-shrink-0 shadow-sm">
                                <i className="fa-solid fa-file-import text-white text-sm"></i>
                            </div>
                            <div>
                                <div className="flex items-center gap-2">
                                    <h2 className="text-sm font-semibold text-gray-800 dark:text-slate-100 leading-tight">
                                        Bulk Shipment Import
                                    </h2>

                                    <label
                                        htmlFor="chkUpdateAwbNo"
                                        className="inline-flex items-center gap-1.5 cursor-pointer select-none py-1.5 px-1 rounded-full border border-gray-200 dark:border-slate-700 bg-gray-50 dark:bg-slate-800 hover:bg-white dark:hover:bg-slate-700 transition"
                                        style={{ marginLeft: "20px" }}
                                    >
                                        <input
                                            id="chkUpdateAwbNo"
                                            type="checkbox"
                                            checked={formData.isUpdateAwbNo}
                                            onChange={(e) =>
                                                setFormData(prev => ({ ...prev, isUpdateAwbNo: e.target.checked }))
                                            }
                                            className="w-3.5 h-3.5 accent-[var(--theme-color)] cursor-pointer"
                                        />
                                        <span className="text-[11px] text-gray-600 dark:text-slate-300 font-medium whitespace-nowrap">
                                            Update Docket No
                                        </span>
                                    </label>
                                </div>
                                <div className="flex items-center gap-1 mt-0.5">
                                    <span className="text-[11px] text-gray-400 dark:text-slate-500">Pickup</span>
                                    <i className="fa-solid fa-chevron-right text-gray-300 dark:text-slate-600 text-[8px]"></i>
                                    <span className="text-[11px] text-[var(--theme-color)] font-medium">Bulk Shipment Import</span>
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center gap-2 flex-wrap">
                            <span className="inline-flex items-center gap-1.5 bg-[var(--brand-lighter)] dark:bg-slate-800 text-[var(--theme-color)] text-[11px] font-medium px-2.5 py-1 rounded-full border border-[var(--brand-light)] dark:border-slate-700">
                                <span className="w-1.5 h-1.5 rounded-full bg-[var(--theme-color)] inline-block"></span>
                                Ready to import
                            </span>


                            <button
                                type="button"
                                onClick={handleReset}
                                className="inline-flex items-center gap-1 text-[11px] text-gray-500 dark:text-slate-400 border border-gray-200 dark:border-slate-700 rounded-full px-2.5 py-1 hover:border-[var(--theme-color)] hover:text-[var(--theme-color)] hover:bg-white dark:hover:bg-slate-800 transition"
                            >
                                <i className="fa-solid fa-rotate-left text-[10px]"></i>
                                Reset
                            </button>
                        </div>
                    </div>

                    {/* Body */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">

                        {/* Left Column */}
                        <div className="flex flex-col gap-2">

                            {/* Step 1 ? Instructions */}
                            <div className="bg-white dark:bg-slate-900/50 border border-gray-100 dark:border-slate-800 rounded-xl p-3">
                                <div className="flex items-center gap-2 mb-2">
                                    <div className="w-5 h-5 rounded-full bg-[var(--theme-color)] text-white flex items-center justify-center text-[10px] font-semibold flex-shrink-0 shadow-xs">
                                        1
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-700 dark:text-slate-300">Before you upload</p>
                                        <p className="text-[11px] text-gray-400 dark:text-slate-500">Check these instructions</p>
                                    </div>
                                </div>
                                <div className="flex flex-col gap-1.5">
                                    {[
                                        {
                                            icon: 'fa-solid fa-file-excel',
                                            text: (<>Upload only Excel file in <strong className="text-gray-700 dark:text-slate-300">.xlsx</strong> format</>),
                                        },
                                        {
                                            icon: 'fa-solid fa-list-check',
                                            text: 'Excel headers must exactly match the required field names',
                                        },
                                        {
                                            icon: 'fa-solid fa-database',
                                            text: (<>Maximum <strong className="text-gray-700 dark:text-slate-300">1,00,000</strong> records per upload</>),
                                        },
                                    ].map((item, i) => (
                                        <div key={i} className="flex items-start gap-2 bg-[var(--brand-lighter)] dark:bg-slate-800 rounded-lg px-2.5 py-1.5 border border-transparent hover:border-[var(--brand-light)] transition-colors">
                                            <i className={`${item.icon} text-[var(--theme-color)] text-[10px] mt-0.5 flex-shrink-0`}></i>
                                            <span className="text-[11px] text-gray-500 dark:text-slate-400">{item.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Step 2 ? Required Columns */}
                            <div className="bg-white dark:bg-slate-900/50 border border-gray-100 dark:border-slate-800 rounded-xl p-3 flex-1">
                                <div className="flex items-center gap-2 mb-2">
                                    <div className="w-5 h-5 rounded-full bg-[var(--theme-color)] text-white flex items-center justify-center text-[10px] font-semibold flex-shrink-0 shadow-xs">
                                        2
                                    </div>
                                    <div>
                                        <p className="text-xs font-medium text-gray-700 dark:text-slate-300">Required columns</p>
                                        <p className="text-[11px] text-gray-400 dark:text-slate-500">Fields must match exactly</p>
                                    </div>
                                </div>

                                <div className="flex flex-wrap gap-1.5 mb-2 overflow-x-hidden" style={{ height: "150px" }}>
                                    {requiredFields1.map((f) => (
                                        <span
                                            key={f.label}
                                            className="inline-flex items-center gap-1 bg-[var(--brand-lighter)] dark:bg-slate-800 text-[var(--theme-color)] dark:text-slate-300 text-[11px] font-medium px-2 py-0.5 rounded-full border border-[var(--brand-light)]/40 hover:border-[var(--theme-color)] transition-colors"
                                        >
                                            <i className={`${f.icon} text-[9px]`}></i>
                                            {f.label}
                                        </span>
                                    ))}
                                    {requiredFields2.map((f) => (
                                        <span
                                            key={f.label}
                                            className="inline-flex items-center gap-1 bg-[var(--brand-lighter)] dark:bg-slate-800 text-[var(--theme-color)] dark:text-slate-300 text-[11px] font-medium px-2 py-0.5 rounded-full border border-[var(--brand-light)]/40 hover:border-[var(--theme-color)] transition-colors"
                                        >
                                            <i className={`${f.icon} text-[9px]`}></i>
                                            {f.label}
                                        </span>
                                    ))}
                                    {requiredFields3.map((f) => (
                                        <span
                                            key={f.label}
                                            className="inline-flex items-center gap-1 bg-[var(--brand-lighter)] dark:bg-slate-800 text-[var(--theme-color)] dark:text-slate-300 text-[11px] font-medium px-2 py-0.5 rounded-full border border-[var(--brand-light)]/40 hover:border-[var(--theme-color)] transition-colors"
                                        >
                                            <i className={`${f.icon} text-[9px]`}></i>
                                            {f.label}
                                        </span>
                                    ))}
                                </div>

                                <div className="flex items-center gap-2 bg-green-50 dark:bg-emerald-950/20 border border-green-100 dark:border-emerald-900/30 rounded-lg px-2.5 py-1.5">
                                    <i className="fa-solid fa-circle-info text-green-600 text-[10px] flex-shrink-0"></i>
                                    <span className="text-[11px] text-green-700 dark:text-emerald-400">
                                        Download the format file to avoid header mismatch errors
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Right Column ? Step 3: Upload */}
                        <div className="bg-white dark:bg-slate-900/50 border border-gray-100 dark:border-slate-800 rounded-xl p-3 flex flex-col gap-2">
                            <div className="flex items-center gap-2">
                                <div className="w-5 h-5 rounded-full bg-[var(--theme-color)] text-white flex items-center justify-center text-[10px] font-semibold flex-shrink-0 shadow-xs">
                                    3
                                </div>
                                <div>
                                    <p className="text-xs font-medium text-gray-700 dark:text-slate-300">Upload your file</p>
                                    <p className="text-[11px] text-gray-400 dark:text-slate-500">Drag & drop or click to browse</p>
                                </div>
                            </div>

                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                fileName={Name}
                                formData={formData}
                                setFormData={setFormData}
                                isUpdateBulk={true}
                            />

                            {/* Inline Progress */}
                            {SubLoad && (
                                <div>
                                    <div className="flex justify-between mb-1">
                                        <span className="text-[11px] text-gray-400">Processing records...</span>
                                        <span className="text-[11px] text-gray-500 font-medium">{percentage}%</span>
                                    </div>
                                    <div className="h-1.5 bg-gray-100 dark:bg-slate-800 rounded-full overflow-hidden">
                                        <div
                                            className="h-full bg-[var(--theme-color)] rounded-full transition-all duration-300"
                                            style={{ width: `${percentage}%` }}
                                        ></div>
                                    </div>
                                    <div className="flex justify-between mt-1">
                                        <span className="text-[10px] text-gray-400">
                                            {progress.processed} / {progress.total} records
                                        </span>
                                        <span className="text-[10px] text-green-600">
                                            {progress.successCount} success
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                </div>
            </div>

        </>
    );
};

export default BulkBookingImport;
